"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ImageFileExtensions = exports.FileIconsMap = void 0;
require("core-js/modules/es.array.reduce.js");
require("core-js/modules/es.symbol.description.js");
var _freeRegularSvgIcons = require("@fortawesome/free-regular-svg-icons");
var _react = _interopRequireDefault(require("react"));
var _reactFontawesome = require("@fortawesome/react-fontawesome");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const ImageFileExtensions = exports.ImageFileExtensions = ['image', 'apng', 'png', 'gif', 'tiff', 'webp', 'jpeg', 'pjpeg', 'jpg'];
const FileIconsMap = exports.FileIconsMap = _objectSpread(_objectSpread({
  'pdf': /*#__PURE__*/_react.default.createElement("span", {
    className: "fileIcon pdf"
  }),
  'doc': /*#__PURE__*/_react.default.createElement(_reactFontawesome.FontAwesomeIcon, {
    className: "faIcon",
    icon: _freeRegularSvgIcons.faFileWord
  }),
  'docx': /*#__PURE__*/_react.default.createElement(_reactFontawesome.FontAwesomeIcon, {
    className: "faIcon",
    icon: _freeRegularSvgIcons.faFileWord
  }),
  'xls': /*#__PURE__*/_react.default.createElement(_reactFontawesome.FontAwesomeIcon, {
    className: "faIcon",
    icon: _freeRegularSvgIcons.faFileExcel
  }),
  'ppt': /*#__PURE__*/_react.default.createElement(_reactFontawesome.FontAwesomeIcon, {
    className: "faIcon",
    icon: _freeRegularSvgIcons.faFilePowerpoint
  }),
  'csv': /*#__PURE__*/_react.default.createElement(_reactFontawesome.FontAwesomeIcon, {
    className: "faIcon",
    icon: _freeRegularSvgIcons.faFile
  })
}, ImageFileExtensions.reduce((acc, ext) => {
  acc[ext] = /*#__PURE__*/_react.default.createElement(_reactFontawesome.FontAwesomeIcon, {
    className: "faIcon",
    icon: _freeRegularSvgIcons.faFileImage
  });
  return acc;
}, {})), {}, {
  'video': /*#__PURE__*/_react.default.createElement(_reactFontawesome.FontAwesomeIcon, {
    className: "faIcon",
    icon: _freeRegularSvgIcons.faFileVideo
  }),
  'default': /*#__PURE__*/_react.default.createElement(_reactFontawesome.FontAwesomeIcon, {
    className: "faIcon",
    icon: _freeRegularSvgIcons.faFileLines
  })
});